import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-334c06e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wallpaper-cont" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "主题", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "壁纸", -1))
const _hoisted_5 = { class: "wallpaper" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "wallpaper-item" }
const _hoisted_8 = ["onClick"]

import { ref, onMounted, reactive } from 'vue';
import {
  RaSelect,
  RaOption,
  RaRadio,
  RaRadioGroup,
  RaCheckbox,
  RaCheckboxGroup,
  RaSlider,
  RaDivider,
} from '@rafter/pc';
import { settings } from '@/store/settings';
import { wallTypeList } from '@/constants/index';

export default /*#__PURE__*/_defineComponent({
  __name: 'Appearance',
  setup(__props) {

const appearance = reactive({
  theme: 'light',
  wallpaper: [],
});
const tab = ref({
  label: '自然',
  value: 'nature',
});
const wallPaperKinds = [
  {
    label: '自然',
    value: 'nature',
  },
  {
    label: '建筑',
    value: 'building',
  },
  {
    label: '动物',
    value: 'animal',
  },
  {
    label: '旅行',
    value: 'travel',
  },
];
const handleWallpaper = (item) => {
  settings.wallpaper = item.url;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(_unref(RaSelect), {
        modelValue: _unref(settings).theme,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings).theme) = $event)),
        class: "theme-select"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(RaOption), {
            value: "light",
            label: "浅色"
          }, {
            default: _withCtx(() => [
              _createTextVNode("浅色")
            ]),
            _: 1
          }),
          _createVNode(_unref(RaOption), {
            value: "dark",
            label: "深色"
          }, {
            default: _withCtx(() => [
              _createTextVNode("深色")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(wallPaperKinds, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.value
          }, [
            (index !== 0)
              ? (_openBlock(), _createBlock(_unref(RaDivider), {
                  key: 0,
                  direction: "vertical"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass({ item: true, active: tab.value.value === item.value }),
              onClick: ($event: any) => (tab.value = item)
            }, _toDisplayString(item.label), 11, _hoisted_6)
          ], 64))
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wallTypeList)[tab.value.value], (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.name,
          style: _normalizeStyle({ background: `url(${item.url})` }),
          onClick: ($event: any) => (handleWallpaper(item))
        }, null, 12, _hoisted_8))
      }), 128))
    ])
  ]))
}
}

})